/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_COSTUME_TYPE = gql`
  query GetCostumeType($filter: UniqCostumeTypeFilterInput!) {
    getCostumeType(filter: $filter) {
      partitions {
        defaultInvites
        sectionID
        sectionSpecificInvites
        specialInvites
      }
      inventoryDetail {
        defaultInvitesRemaining
        specialInvitesRemaining
        sectionSpecificInvitesRemaining
        defaultInvitesUsed
        specialInvitesUsed
        sectionSpecificInvitesUsed
        isDefaultSold
        isSpecialReserveSold
        isSectionSpecificSold
      }
    }
  }
`;

export const UPDATE_COSTUME_TYPE = gql`
  mutation UpdateCostumeType(
    $filter: UniqCostumeTypeFilterInput!
    $update: CostumeTypeUpdateInput!
  ) {
    updateCostumeType(filter: $filter, update: $update) {
      id
      partitions {
        defaultInvites
        section {
          id
          name
        }
        sectionSpecificInvites
        specialInvites
      }
    }
  }
`;
